
import { Box, Divider, Button, Stack, Grid, InputAdornment, Typography, Tooltip, IconButton, Autocomplete, TextField, useTheme, Card, CardHeader, CardContent } from "@mui/material";
import { styled } from '@mui/material/styles';
import { useState, useEffect } from "react";
import CallAlertBar from "../../../Layout/Alertbar";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';

// icon
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';
import Close from '@mui/icons-material/Close';
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import useManageEmployeeResignationStatus from "../../../hooks/useEmployeeResignationStatus";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DownloadIcon from '@mui/icons-material/FileDownloadOutlined';
import UploadSection from "../../../components/upload-documents/UploadSection";
import ExitInterviewChecklist from "./ExitInterviewChecklist";
import { Visibility, VisibilityOff } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import PhoneIcon from '@mui/icons-material/Phone';
import AddIcon from '@mui/icons-material/Add';

import useBankAccountType from "../../../hooks/useBankAccountType";


const ExitEmployee = ({ handlecallback, editEmployeeID, employee_code, dateOfJoinning }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // Parent Roll  Alert Values
    const [msgOpen, setMsgOpen] = useState(false);
    const [severityValue, setSeverityvalue] = useState('info');
    const [messageValue, setMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [alertTitleValue, setAlertTitleValue] = useState('');
    const [selectedButton, setSelectedButton] = useState(null);
    const [nomineeName, setNomineeName] = useState('');
    const [nomineeRelation, setNomineeRelation] = useState('');

    const callback = () => { handlecallback(); }
    const [isDataLoad, setIsDataLoad] = useState(false);
    const { resignationStatus, loading, error, success, fetchResignationStatus, ResignationStatusCRUDOperation, setSuccess, selectedResignationStatus, setSelectedResignationStatus } = useManageEmployeeResignationStatus();
    // hook call
    const { bankAccounts, selectedBankAccounts, selectedBankAccountID, setSelectedBankAccounts, setSelectedBankAccountID, loadBankAccountByID, } = useBankAccountType(0);

    //-- get Project Number
    const [employeeCode, setEmployeeCode] = useState([]);
    const [isProjectNumberLoaded, setIsProjectNumberLoaded] = useState(false);
    const [reasonForExit, setReasonForExit] = useState('');

    const [resignationDate, setResignationDate] = useState(dayjs());
    const [approvedLWD, setApprovedLWD] = useState(dayjs());
    const [actualLWD, setActualLWD] = useState(dayjs());

    const [exitInterviewDetails, setExitInterviewDetails] = useState('');
    const [settlementStatus, setSettlementStatus] = useState('');

    // Project Lead   
    const [employeeExitID, setEmployeeExitID] = useState(0);


    // employee status 
    const [isEmployeeDetailLoaded, setIsEmployeeDetailLoaded] = useState(false);


    //questionairre
    const [workingOrganization, setWorkOrganization] = useState('');
    const [likeOrganizationRemark, setLikeOrganizationRemark] = useState('');
    const [improveStaffWalfareRemark, setImproveStaffWalfareRemark] = useState('');
    const [wishToShareRemark, setWishToShareRemark] = useState('');

    // checklist for exit interview
    const [companyVehicleHanded, setCompanyVehicleHanded] = useState('');
    const [allEquipmentHanded, setAllEquipment] = useState('');
    const [libraryBookHanded, setLibraryBookHanded] = useState('');
    const [securityHanded, setSecurityHanded] = useState('');
    const [exitInterViewHanded, setExitInterViewHanded] = useState('');
    const [noticePeriodFollowed, setNoticePeriodFollowed] = useState('');
    const [resignationLetterSubmitted, setResignationLetterSubmitted] = useState('');
    const [managerClearnce, setManagerClearnce] = useState('');

    const [updateProgress, setUpdateProgress] = useState(true);
    const [isUpdateProgress, setIsUpdateProgress] = useState(false);

    const [documents, setDocuments] = useState({
        Resignation: { file: null, base64: null },
        HRClearness: { file: null, base64: null },
        DeathCertificate: { file: null, base64: null }
    });


    const CustomTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} arrow placement="right-start" />
    ))({
        [`& .MuiTooltip-tooltip`]: {
            backgroundColor: colors.blueAccent[500],
            color: 'white',
            fontSize: '14px',
            borderRadius: '10px',
            padding: '10px',

        },
        [`& .MuiTooltip-arrow`]: {
            color: colors.blueAccent[500],
        },
    });


    useEffect(() => {
        if (!isUpdateProgress) {
            if (editEmployeeID === 0) {
                setUpdateProgress(false);
            }
        }

    }, [editEmployeeID])


    //load employee exit status
    useEffect(() => {
        const loadData = async () => {
            if (!isDataLoad) {
                await fetchResignationStatus('');
                setIsDataLoad(true);
            }
        };

        loadData();
    }, []);

    useEffect(() => {
        const fetchEmployeeExitDetails = async () => {
            if (editEmployeeID !== 0 && !isEmployeeDetailLoaded) {
                setEmployeeCode(employee_code);

                const para = {
                    p_companyid: localStorage.getItem('companyid'),
                    p_employeeid: editEmployeeID,
                };

                try {
                    const data = await callApi(
                        API_ENDPOINTS.HR_GET_EMPLOYEE_EXIT_DETAIL,
                        'POST',
                        { 'Content-Type': 'application/json' },
                        para
                    );

                    if (data && data.length > 0) {
                        const d = data[0];
                        setReasonForExit(d.p_reason_for_exit);
                        setResignationDate(d.p_resignation_date);
                        setApprovedLWD(d.p_approved_lwd);
                        setActualLWD(d.p_actial_lwd);
                        setExitInterviewDetails(d.p_exit_interview_details);
                        setSettlementStatus(d.p_settlement_status);
                        setEmployeeExitID(d.p_employee_exit_id);
                        // setUpdateExitStatus(d.p_exit_status);

                        setNomineeName(d.nominee_name);
                        setNomineeRelation(d.relationship_with_nominee);
                        setWorkOrganization(d.working_for_this_organization);
                        setLikeOrganizationRemark(d.like_the_most_of_the_organization);
                        setImproveStaffWalfareRemark(d.improve_staff_welfare);
                        setWishToShareRemark(d.wish_to_share);
                        setCompanyVehicleHanded(d.company_vehicle);
                        setAllEquipment(d.all_equipment_handed);
                        setLibraryBookHanded(d.library_book_submitted);
                        setSecurityHanded(d.security);
                        setExitInterViewHanded(d.interview_conducted);
                        setNoticePeriodFollowed(d.notice_period_followed);
                        setResignationLetterSubmitted(d.resignation_letter_submitted);
                        setManagerClearnce(d.manager_clearance);

                        // bank detail
                        // Parse bank_details if it's a JSON string
                        const bankDetailsData = typeof data[0].bank_details === 'string'
                            ? JSON.parse(data[0].bank_details)
                            : data[0].bank_details;

                        if (Array.isArray(bankDetailsData) && bankDetailsData.length > 0) {
                            setBankDetails(bankDetailsData);
                        } else {
                            //setBankDetails([]); // clear or reset if no valid data
                        }



                        // update check list data format to form data 
                        // ✅ Set formData in one go with checklist fields
                        setFormData({
                            ...formData, // if you want to keep previously filled values (optional)

                            vehicleHandedIn: d.vehicle_handed_in || false,
                            vehicleHandedIn_remarks: d.vehicle_handed_in_remarks || '',

                            equipmentHandedIn: d.equipment_handed_in || false,
                            equipmentHandedIn_remarks: d.equipment_handed_in_remarks || '',

                            libraryBooksSubmitted: d.library_books_submitted || false,
                            libraryBooksSubmitted_remarks: d.library_books_submitted_remarks || '',

                            accessCardReturned: d.access_card_returned || false,
                            accessCardReturned_remarks: d.access_card_returned_remarks || '',

                            interviewConducted: d.interview_conducted_chk || false,
                            interviewConducted_remarks: d.interview_conducted_remarks || '',

                            resignationSubmitted: d.resignation_submitted || false,
                            resignationSubmitted_remarks: d.resignation_submitted_remarks || '',

                            ndaSigned: d.nda_signed || false,
                            ndaSigned_remarks: d.nda_signed_remarks || '',

                            pfFormSubmitted: d.pf_form_submitted || false,
                            pfFormSubmitted_remarks: d.pf_form_submitted_remarks || '',

                            gratuityFormSubmitted: d.gratuity_form_submitted || false,
                            gratuityFormSubmitted_remarks: d.gratuity_form_submitted_remarks || '',

                            systemAccessRevoked: d.system_access_revoked || false,
                            systemAccessRevoked_remarks: d.system_access_revoked_remarks || '',

                            emailDeactivated: d.email_deactivated || false,
                            emailDeactivated_remarks: d.email_deactivated_remarks || '',

                            biometricDisabled: d.biometric_disabled || false,
                            biometricDisabled_remarks: d.biometric_disabled_remarks || '',

                            finalApprovedBy: d.final_approved_by || '',
                            finalExitConfirmed: d.final_exit_confirmed || false,
                        });


                        // Parse contact_details if it's a JSON string
                        const documentDetailsData = typeof data[0].document_details === 'string'
                            ? JSON.parse(data[0].document_details)
                            : data[0].document_details;

                        if (documentDetailsData && documentDetailsData.length > 0) {
                            const newDocs = { ...documents };

                            documentDetailsData.forEach((doc) => {
                                if (doc.document_value && doc.document_type) {
                                    const encoded = doc.document_value;
                                    const uriEncoded = encoded.replace(/\\x/g, '%');
                                    const base64Data = decodeURIComponent(uriEncoded);

                                    switch (doc.document_type) {
                                        case 'Resignation_File':
                                            newDocs.Resignation = {
                                                file: doc.document_name || null,
                                                base64: base64Data
                                            };
                                            break;

                                        case 'HR_Clearness_File':
                                            newDocs.HRClearness = {
                                                file: doc.document_name || null,
                                                base64: base64Data
                                            };
                                            break;

                                        case 'Death_Certificate':
                                            newDocs.DeathCertificate = {
                                                file: doc.document_name || null,
                                                base64: base64Data
                                            };
                                            break;

                                        default:
                                            break;
                                    }
                                }
                            });

                            setDocuments(newDocs);
                        }


                        await fetchResignationStatus({ selectVal: d.p_exit_status });

                        setUpdateProgress(false);
                    }
                } catch (error) {
                    CallMessage('error', error.message || 'Error loading exit details', 'Error');
                }
            }
        };

        fetchEmployeeExitDetails();
    }, [editEmployeeID]);



    // load Project Number

    useEffect(() => {
        if (!isProjectNumberLoaded) {

            if (editEmployeeID === 0) {

                const para = {
                    p_companyid: 1,
                    p_modeid: 0,
                }

                callApi(API_ENDPOINTS.HR_GET_EMPLOYEE_NUMBER, 'POST', { 'Content-Type': 'application/json' }, para)
                    .then(data => {
                        if (data?.length > 0) { setEmployeeCode(data[0].po_number); }
                    })
                    .catch(error => { CallMessage('error', error.message, 'Error'); });
            }
        }
    }, [isProjectNumberLoaded]);


    // Display Message

    const CallMessage = (serverityval, msg, title) => {
        setSeverityvalue(serverityval);
        setMessageValue(msg);
        setAlertTitleValue(title);
        setMsgOpen(true);
    };

    // update exit employee details

    const SaveExitEmployeeDetail = async () => {

        let modevalue = employeeExitID !== 0 ? 1 : 0;
        const preparedBankDetails = await prepareBankDetails();

        const para = {
            p_companyid: localStorage.getItem('companyid'),
            p_modeid: modevalue,
            p_employeeid: editEmployeeID,
            p_reason_for_exit: reasonForExit,
            p_resignation_date: resignationDate,
            p_approved_lwd: approvedLWD,
            p_actial_lwd: actualLWD,
            //p_exit_status: selectedEmployeeStatus.description,
            p_exit_status: selectedResignationStatus.description,
            p_exit_interview_details: exitInterviewDetails,
            p_settlement_status: settlementStatus,
            p_employee_exit_id: employeeExitID,
            p_nominee_name: nomineeName,
            p_relationship_with_nominee: nomineeRelation,
            p_working_for_this_organization: workingOrganization,
            p_like_the_most_of_the_organization: likeOrganizationRemark,
            p_improve_staff_welfare: improveStaffWalfareRemark,
            p_wish_to_share: wishToShareRemark,

            p_company_vehicle: companyVehicleHanded,
            p_all_equipment_handed: allEquipmentHanded,
            p_library_book_submitted: libraryBookHanded,
            p_security: securityHanded,
            p_interview_conducted: exitInterViewHanded,
            p_notice_period_followed: noticePeriodFollowed,
            p_resignation_letter_submitted: resignationLetterSubmitted,
            p_manager_clearance: managerClearnce,
            p_created_by: localStorage.getItem('userID'),
            p_plantid: 1,

            p_resignation_file: documents.Resignation.base64,
            p_hr_clearness_file: documents.HRClearness.base64,
            p_death_certificate_file: documents.DeathCertificate.base64,
            p_resignation_filename: documents.Resignation.file,
            p_hr_clearness_filename: documents.HRClearness.file,
            p_death_certificate_filename: documents.DeathCertificate.file,


            // check list changes
            vehicle_handed_in: formData.vehicleHandedIn || false,
            vehicle_handed_in_remarks: formData.vehicleHandedIn_remarks || '',
            equipment_handed_in: formData.equipmentHandedIn || false,
            equipment_handed_in_remarks: formData.equipmentHandedIn_remarks || '',
            library_books_submitted: formData.libraryBooksSubmitted || false,
            library_books_submitted_remarks: formData.libraryBooksSubmitted_remarks || '',
            access_card_returned: formData.accessCardReturned || false,
            access_card_returned_remarks: formData.accessCardReturned_remarks || '',

            interview_conducted: formData.interviewConducted || false,
            interview_conducted_remarks: formData.interviewConducted_remarks || '',
            resignation_submitted: formData.resignationSubmitted || false,
            resignation_submitted_remarks: formData.resignationSubmitted_remarks || '',
            nda_signed: formData.ndaSigned || false,
            nda_signed_remarks: formData.ndaSigned_remarks || '',
            pf_form_submitted: formData.pfFormSubmitted || false,
            pf_form_submitted_remarks: formData.pfFormSubmitted_remarks || '',
            gratuity_form_submitted: formData.gratuityFormSubmitted || false,
            gratuity_form_submitted_remarks: formData.gratuityFormSubmitted_remarks || '',

            system_access_revoked: formData.systemAccessRevoked || false,
            system_access_revoked_remarks: formData.systemAccessRevoked_remarks || '',
            email_deactivated: formData.emailDeactivated || false,
            email_deactivated_remarks: formData.emailDeactivated_remarks || '',
            biometric_disabled: formData.biometricDisabled || false,
            biometric_disabled_remarks: formData.biometricDisabled_remarks || '',

            final_approved_by: formData.finalApprovedBy || '',
            final_exit_confirmed: formData.finalExitConfirmed || false,

            nominee_bank_details: preparedBankDetails
            // public List<JObject> p_party_bank_details { get; set; }
        }
        callApi(API_ENDPOINTS.HR_CRUD_EMPLOYEE_EXIT, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data?.length > 0) {
                    let message = employeeExitID === 0 ? 'Employee Exit Detail added successfully' : 'Employee Exit Detail updated successfully';
                    CallMessage('info', message, 'Info');
                }
            })
            .catch(error => { CallMessage('error', error.message, 'Error'); });
    };


    const getYearsOfService = (dateOfJoining) => {
        const joinDate = new Date(dateOfJoining);
        const today = new Date();

        let years = today.getFullYear() - joinDate.getFullYear();

        // Adjust if the current date is before the joining anniversary this year
        const hasNotCompletedYear =
            today.getMonth() < joinDate.getMonth() ||
            (today.getMonth() === joinDate.getMonth() && today.getDate() < joinDate.getDate());

        if (hasNotCompletedYear) {
            years -= 1;
        }

        return years;
    };

    const getYearsAndMonthsOfService = (dateOfJoining) => {
        const joinDate = new Date(dateOfJoining);
        const today = new Date();

        let years = today.getFullYear() - joinDate.getFullYear();
        let months = today.getMonth() - joinDate.getMonth();
        const days = today.getDate() - joinDate.getDate();

        if (months < 0 || (months === 0 && days < 0)) {
            years -= 1;
            months += 12;
        }

        if (days < 0) {
            months -= 1;
            if (months < 0) {
                years -= 1;
                months += 12;
            }
        }

        return `${years} year(s) ${months} month(s)`;

    };

    // Sample options
    const yesNoOptions = ['Yes', 'No'];

    const handleFileChange = (file, type) => {
        if (!file) return;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const base64String = reader.result.split(',')[1];
            setDocuments(prev => ({
                ...prev,
                [type]: { file: file.name, base64: base64String }
            }));
        };
    };

    const handleDownload = (type) => {
        const doc = documents[type];
        if (!doc?.base64 || !doc?.file) {
            alert("No file found.");
            return;
        }

        const link = document.createElement('a');
        link.href = `data:application/pdf;base64,${doc.base64}`;
        link.download = doc.file;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const [formData, setFormData] = useState([]);


    // bank details
    const [accountMismatch, setAccountMismatch] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [status, setStatus] = useState('Active');
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault(); // Prevents focusing on the button when clicked
    };

    const handleInputChange = (index, e) => {
        const { name, value } = e.target;
        const newBankDetails = [...bankDetails];
        newBankDetails[index][name] = value;
        setBankDetails(newBankDetails);
    };

    const handleChequeInputChange = (index, e) => {
        const file = e.target.files[0];
        if (!file) return;

        const newBankDetails = [...bankDetails];
        newBankDetails[index]['cancelledCheque'] = file;
        newBankDetails[index]['cancelledCheque_file_name'] = file.name;
        setBankDetails(newBankDetails);
    };

    const handleRTGSInputChange = (index, e) => {
        const file = e.target.files[0];
        if (!file) return;

        const newBankDetails = [...bankDetails];
        newBankDetails[index]['rtgsDetail'] = file;
        newBankDetails[index]['rtgsDetail_file_name'] = file.name;
        setBankDetails(newBankDetails);
    };

    const handleBankLetterInputChange = (index, e) => {
        const file = e.target.files[0];
        if (!file) return;

        const newBankDetails = [...bankDetails];
        newBankDetails[index]['bankLetter'] = file;
        newBankDetails[index]['bankLetter_file_name'] = file.name;
        setBankDetails(newBankDetails);
    };

    const handleDownloadBankLetter = (index, e, docType) => {
        try {

            const bank = [...bankDetails];

            let rawData = null;
            let fileName = '';

            if (docType === 'bank_letter') {
                rawData = bank[index]?.bankLetter;
                fileName = bank[index]?.bankLetter_file_name || 'bank_letter.pdf';
            }
            else if (docType === 'rtgs') {
                rawData = bank[index]?.rtgsDetail;
                fileName = bank[index]?.rtgsDetail_file_name || 'rtgs.pdf';
            }
            else if (docType === 'cancel_cheque') {
                rawData = bank[index]?.cancelledCheque;
                fileName = bank[index]?.cancelledCheque_file_name || 'cancelled_cheque.pdf';
            }

            if (!rawData) {
                alert("No file found.");
                return;
            }

            let byteArray;

            if (rawData.startsWith('\\x')) {
                // Hex format (\xNN\xNN...)
                const hexString = rawData.replace(/\\x/g, '');
                const hexPairs = hexString.match(/.{1,2}/g); // Split into byte pairs
                if (!hexPairs) throw new Error("Invalid hex format");

                const byteNumbers = hexPairs.map(h => parseInt(h, 16));
                byteArray = new Uint8Array(byteNumbers);
            } else {
                // Assume it's base64
                try {
                    const byteCharacters = atob(rawData);
                    const byteNumbers = new Array(byteCharacters.length)
                        .fill()
                        .map((_, i) => byteCharacters.charCodeAt(i));
                    byteArray = new Uint8Array(byteNumbers);
                } catch (base64Err) {
                    throw new Error("Invalid base64 format");
                }
            }

            // Download logic
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url); // Clean up
        } catch (error) {
            console.error("Download error:", error);
            alert("An error occurred while downloading the file.");
        }
    };

    const handleAutocompleteChange = (index, field, value) => {
        const updatedDetails = [...bankDetails];
        updatedDetails[index][field] = value;
        setBankDetails(updatedDetails);
    };


    const addBankDetail = () => {
        if (accountMismatch) {
            alert("Fix account number mismatch before continuing");
            return; // 🚫 stops further processing
        }


        setBankDetails([...bankDetails, {
            accountHolderName: '',
            bankName: '',
            accountNumber: '',
            reEnterAccountNumber: '',
            ifsc: '',
            accountTypeId: '',
            branchName: '',
            bankAddress: '',
            contactNumber: '',
            cancelledCheque: null,
            cancelledCheque_file_name: '',
            rtgsDetail: null,
            rtgsDetail_file_name: '',
            bankLetter: null,
            bankLetter_file_name: '',
            id_document: 0,
            document_type: '',
            bank_id_val: 0,
        }]);
    };

    const [bankDetails, setBankDetails] = useState([{
        accountHolderName: '',
        bankName: '',
        accountNumber: '',
        reEnterAccountNumber: '',
        ifsc: '',
        accountTypeId: '',
        branchName: '',
        bankAddress: '',
        contactNumber: '',
        cancelledCheque: null,
        cancelledCheque_file_name: '',
        rtgsDetail: null,
        rtgsDetail_file_name: '',
        bankLetter: null,
        bankLetter_file_name: '',
        id_document: 0,
        document_type: '',
        bank_id_val: 0,
    }]);


    const removeBankDetail = (index) => {
        const newBankDetails = bankDetails.filter((_, i) => i !== index);
        setBankDetails(newBankDetails);
    };

    const [isModalAccountOpen, setIsModalAccountOpen] = useState(false);

    const handleOpenModal = () => {
        setIsModalAccountOpen(true);
    };

    const convertFileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                try {
                    const result = reader.result;
                    const base64 = result.split(',')[1]; // Safely remove MIME prefix
                    resolve(base64);
                } catch (err) {
                    reject(err);
                }
            };
            reader.onerror = reject;
        });
    };


    const isBlob = (file) => file instanceof Blob || file instanceof File;

    const prepareBankDetails = async () => {
        try {
            const updatedBankDetails = await Promise.all(
                bankDetails.map(async (item) => {
                    let cancelledChequeBase64 = null;
                    let rtgsDetailBase64 = null;
                    let bankLetterBase64 = null;

                    try {
                        if (isBlob(item.cancelledCheque)) {
                            cancelledChequeBase64 = await convertFileToBase64(item.cancelledCheque);
                        } else if (typeof item.cancelledCheque === 'string') {
                            cancelledChequeBase64 = item.cancelledCheque;
                        }
                    } catch (err) {
                        console.error("Error converting Cancelled Cheque:", err);
                    }

                    try {
                        if (isBlob(item.rtgsDetail)) {
                            rtgsDetailBase64 = await convertFileToBase64(item.rtgsDetail);
                        } else if (typeof item.rtgsDetail === 'string') {
                            rtgsDetailBase64 = item.rtgsDetail;
                        }
                    } catch (err) {
                        console.error("Error converting RTGS Detail:", err);
                    }

                    try {
                        if (isBlob(item.bankLetter)) {
                            bankLetterBase64 = await convertFileToBase64(item.bankLetter);
                        } else if (typeof item.bankLetter === 'string') {
                            bankLetterBase64 = item.bankLetter;
                        }
                    } catch (err) {
                        console.error("Error converting Bank Letter:", err);
                    }

                    return {
                        ...item,
                        cancelledCheque: cancelledChequeBase64,
                        cancelledCheque_file_name: item.cancelledCheque?.name || item.cancelledCheque_file_name || null,
                        rtgsDetail: rtgsDetailBase64,
                        rtgsDetail_file_name: item.rtgsDetail?.name || item.rtgsDetail_file_name || null,
                        bankLetter: bankLetterBase64,
                        bankLetter_file_name: item.bankLetter?.name || item.bankLetter_file_name || null,
                    };
                })
            );

            return updatedBankDetails;
        } catch (err) {
            console.error("prepareBankDetails error:", err);
            return [];
        }
    };


    useEffect(() => {
        if (!updateProgress) {
            bankDetails.forEach((bank, index) => {
                const ifsc = bank.ifsc?.trim();
                if (ifsc && ifsc.length === 11) {
                    fetch(`https://ifsc.razorpay.com/${ifsc}`)
                        .then(res => {
                            if (!res.ok) throw new Error("Invalid IFSC");
                            return res.json();
                        })
                        .then(data => {
                            const updated = [...bankDetails];
                            updated[index] = {
                                ...updated[index],
                                bankName: data.BANK,
                                branchName: data.BRANCH,
                                bankAddress: data.ADDRESS,
                                contactNumber: data.CONTACT?.replace(/^(\+91)/, '') // Removes +91 from start
                            };
                            setBankDetails(updated);
                        })
                        .catch(err => {
                            console.error(`IFSC fetch failed for index ${index}`, err);
                        });
                }
            });
        }

    }, [bankDetails.map(b => b.ifsc).join(',')]); // triggers when any IFSC changes

    return (<>
        <Box>

            <Grid container justifyContent="space-between" alignItems="center" padding={0}>
                {/* Left-aligned: Edit Employee */}
                <Grid item>
                    <Typography variant="h4" sx={{ textAlign: "center", width: "100%", marginLeft: "10px", alignItems: "center" }}>
                        {editEmployeeID === 0 ? 'Exit Employee' : 'Exit Employee'}
                    </Typography>
                </Grid>

                {/* Right-aligned: Buttons */}
                <Grid item>
                    <Grid container alignItems="center">
                        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                        {/* Save */}
                        <Grid item ml={1} mr={1}>
                            <Tooltip title="Add new orders">
                                <IconButton
                                    onClick={() => { SaveExitEmployeeDetail() }}
                                    sx={{ display: 'flex', alignItems: 'center' }}
                                    type="submit"
                                // disabled={saveButtonDisabled}
                                >
                                    <ReceiptRoundedIcon style={{ fontSize: "18px", color: selectedButton === 'save' ? "yellow" : "#009688" }} />
                                    <Typography variant="body2" sx={{ ml: 1 }}>  {employeeExitID !== 0 ? 'Edit' : 'Save'}</Typography>
                                </IconButton>
                            </Tooltip>
                        </Grid>

                        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                        <IconButton onClick={callback}>
                            {/* onClick={callback} */}
                            <Close style={{ fontSize: "14px", color: "#2196F3" }} />
                        </IconButton>
                        <Divider orientation="vertical" flexItem
                        // sx={{ mx: 1 }}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Divider />

            {/* Message box detail */}
            <CallAlertBar parentRollMsgOpen={msgOpen} setParentRollMsgOpen={setMsgOpen} parentRollSeverityvalue={severityValue}
                setParentRollSeverityvalue={setSeverityvalue} parentRollAlertTitleValue={alertTitleValue}
                setParentRollAlertTitleValue={setAlertTitleValue} parentRollMessageValue={messageValue} setParentRollMessageValue={setMessageValue} />


            {/* Adjust screen size based on moniter */}
            <Box
                sx={{
                    padding: "10px",
                    borderRadius: "10px",
                    maxHeight: {
                        xs: '72vh', // Extra small devices (phones)
                        sm: '72vh', // Small devices (tablets)
                        md: '74vh', // Medium devices (small laptops)
                        lg: '84vh', // Large devices (desktops)
                        xl: '89vh', // Extra large devices (large desktops)
                    },
                    overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                    '&::-webkit-scrollbar': {
                        width: '8px',
                    },
                    '&::-webkit-scrollbar-track': {
                        background: colors.primary[400],
                        borderRadius: '10px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        background: colors.blueAccent[600],
                        borderRadius: '10px',
                        '&:hover': {
                            background: colors.blueAccent[800],
                        },
                    },
                    '&::-webkit-scrollbar-corner': {
                        background: colors.primary[700],
                    }
                }}>

                <Grid container spacing={2} >
                    <Grid item xs={12} sm={12} md={12} lg={11.8} xl={11.8} mt={2}>
                        <Card sx={{ backgroundColor: colors.primary[500] }}>
                            <CardHeader title="Basic Exit Details" />
                            <Divider />
                            <CardContent>
                                <Grid container spacing={2} padding={2}>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"  >

                                            <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                                <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Employee Code
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={4} lg={3.5} xl={3}>
                                                <TextField value={employeeCode} fullWidth size="small" label="" required variant="outlined" />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                                <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Years of Service
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={11} md={4} lg={3.5} xl={3}>
                                                <TextField value={getYearsAndMonthsOfService(dateOfJoinning)} fullWidth size="small" label="" required variant="outlined" />
                                            </Grid>

                                        </Grid>

                                    </Grid>

                                    <Grid item xs={12} xl={12} >
                                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"  >

                                            <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2} display="flex-start" justifyContent="center" >
                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Date of Joining
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={4} lg={3.5} xl={3}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <Stack spacing={2}>
                                                        <DatePicker
                                                            disabled
                                                            size="small"
                                                            id="Orderdate"
                                                            value={dayjs(dateOfJoinning)}
                                                            // onChange={(date) => setResignationDate(date)}
                                                            slotProps={{ textField: { size: 'small' } }}
                                                            fullWidth
                                                            format="DD-MMM-YYYY"
                                                            className="customDatePicker"
                                                            renderInput={(props) => (
                                                                <TextField required {...props} />
                                                            )}
                                                        />
                                                    </Stack>
                                                </LocalizationProvider>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                                <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Reason For Leaving
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={4} lg={3.5} xl={3}>
                                                <TextField value={reasonForExit} onChange={(e) => { setReasonForExit(e.target.value) }} fullWidth size="small" label="" required variant="outlined" />
                                            </Grid>

                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} xl={12} >
                                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"  >

                                            <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2} display="flex-start" justifyContent="center" >
                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Resignation Date
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={4} lg={3.5} xl={3}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <Stack spacing={2}>
                                                        <DatePicker
                                                            size="small"
                                                            id="Orderdate"
                                                            value={dayjs(resignationDate)}
                                                            onChange={(date) => setResignationDate(date)}
                                                            slotProps={{ textField: { size: 'small' } }}
                                                            fullWidth
                                                            format="DD-MMM-YYYY"
                                                            className="customDatePicker"
                                                            renderInput={(props) => (
                                                                <TextField required {...props} />
                                                            )}
                                                        />
                                                    </Stack>
                                                </LocalizationProvider>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2} display="flex-start" justifyContent="center" >
                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Approved LWD
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={4} lg={3.5} xl={3}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <Stack spacing={2}>
                                                        <DatePicker
                                                            size="small"
                                                            id="Orderdate"
                                                            value={dayjs(approvedLWD)}
                                                            onChange={(date) => setApprovedLWD(date)}
                                                            slotProps={{ textField: { size: 'small' } }}
                                                            fullWidth
                                                            format="DD-MMM-YYYY"
                                                            className="customDatePicker"
                                                            renderInput={(props) => (
                                                                <TextField required {...props} />
                                                            )}
                                                        />
                                                    </Stack>
                                                </LocalizationProvider>
                                            </Grid>

                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} xl={12} >
                                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"  >

                                            <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2} display="flex-start" justifyContent="center" >
                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Actual LWD
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={4} lg={3.5} xl={3}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <Stack spacing={2}>
                                                        <DatePicker
                                                            size="small"
                                                            id="Orderdate"
                                                            value={dayjs(actualLWD)}
                                                            onChange={(date) => setActualLWD(date)}
                                                            slotProps={{ textField: { size: 'small' } }}
                                                            fullWidth
                                                            format="DD-MMM-YYYY"
                                                            className="customDatePicker"
                                                            renderInput={(props) => (
                                                                <TextField required {...props} />
                                                            )}
                                                        />
                                                    </Stack>
                                                </LocalizationProvider>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                                <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Exit Status
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={4} lg={3.5} xl={3}>

                                                {/* <Autocomplete
                                        size="small"
                                        fullWidth
                                        value={selectedEmployeeStatus}
                                        onChange={(event, newValue) => { setSelectedEmployeeStatus(newValue); setEmployeeStatusID(newValue.id); }}
                                        options={employeeStatus}
                                        getOptionLabel={(option) => option.description || ''}
                                        renderInput={(params) => (
                                            <TextField {...params} label="" required variant="outlined" />
                                        )}
                                    /> */}
                                                <Autocomplete
                                                    size="small"
                                                    fullWidth
                                                    value={selectedResignationStatus}
                                                    onChange={(event, newValue) => { setSelectedResignationStatus(newValue); }}
                                                    options={resignationStatus}
                                                    getOptionLabel={(option) => option.description || ''}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="" required variant="outlined" />
                                                    )}
                                                />
                                            </Grid>

                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>


                        {/* 3. Nominee Details */}
                        <Card sx={{ backgroundColor: colors.primary[500], marginTop: '20px', marginBottom: '20px' }}>
                            <CardHeader title="Nominee & Gratuity" />
                            <Divider />
                            <CardContent>
                                <Grid container spacing={2} padding={2}>

                                    <Grid item xs={12} xl={12} >
                                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"  >

                                            <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2} display="flex-start" justifyContent="center" >
                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Nominee Name
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={4} lg={3.5} xl={3}>
                                                <TextField value={nomineeName} onChange={(e) => setNomineeName(e.target.value)} fullWidth size="small" />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                                <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Relationship with Nominee
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={4} lg={3.5} xl={3}>
                                                <TextField value={nomineeRelation} onChange={(e) => setNomineeRelation(e.target.value)} fullWidth size="small" />
                                            </Grid>

                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} xl={12} >
                                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"  >

                                            <Grid item xs={12} sm={12} md={5} lg={5} xl={5} display="flex-start" justifyContent="center" >
                                                <Typography fontSize={14} color="textSecondary">
                                                    Legal heir documents required if nominee is not declared.
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>

                        {/* 3. Nominee Bank Details */}
                        <Card sx={{ backgroundColor: colors.primary[500], marginTop: '20px', marginBottom: '20px' }}>
                            <CardHeader title="Bank Detail" />
                            <Divider />
                            <CardContent>
                                {/* <Grid container spacing={2} padding={2}>

                                    <Grid item xs={12} xl={12} >
                                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"  > */}

                                {/* <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2} display="flex-start" justifyContent="center" >
                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Nominee Name
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={4} lg={3.5} xl={3}>
                                                <TextField value={nomineeName} onChange={(e) => setNomineeName(e.target.value)} fullWidth size="small" />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                                <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Relationship with Nominee
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={4} lg={3.5} xl={3}>
                                                <TextField value={nomineeRelation} onChange={(e) => setNomineeRelation(e.target.value)} fullWidth size="small" />
                                            </Grid> */}

                                <Box>
                                    {bankDetails.map((bankDetail, index) => (


                                        <Grid container spacing={2} padding={2} key={index}>
                                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                <Grid container >
                                                    <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                                        <Typography variant="h6" fontSize={16} textAlign="left" sx={{ marginTop: 2, marginBottom: 1 }}>
                                                            Bank {index + 1}
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                            <Grid item xs={12} sm={12} md={3.2} lg={3} xl={2.6} display="flex-start" justifyContent="center">
                                                                <Typography variant="h6" fontSize={14} textAlign="left">
                                                                    Account Holder Name
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={11} md={7.6} lg={7.2} xl={6.8}>
                                                                <TextField
                                                                    fullWidth
                                                                    size="small"
                                                                    name="accountHolderName"
                                                                    value={bankDetail.accountHolderName}
                                                                    onChange={(e) => handleInputChange(index, e)}
                                                                    label=""
                                                                    variant="outlined"
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                            <Grid item xs={12} sm={12} md={3.2} lg={3} xl={2.6} display="flex-start" justifyContent="center">
                                                                <Typography variant="h6" fontSize={14} textAlign="left">
                                                                    IFSC
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={11} md={7.6} lg={7.2} xl={6.8}>
                                                                <TextField
                                                                    fullWidth
                                                                    size="small"
                                                                    name="ifsc"
                                                                    value={bankDetail.ifsc}
                                                                    onChange={(e) => handleInputChange(index, e)}
                                                                    label=""
                                                                    variant="outlined"
                                                                />
                                                            </Grid>


                                                        </Grid>
                                                    </Grid>


                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                            <Grid item xs={12} sm={12} md={3.2} lg={3} xl={2.6} display="flex-start" justifyContent="center">
                                                                <Typography variant="h6" fontSize={14} textAlign="left">
                                                                    Bank Name
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={11} md={7.6} lg={7.2} xl={6.8}>
                                                                <TextField
                                                                    fullWidth
                                                                    size="small"
                                                                    name="bankName"
                                                                    value={bankDetail.bankName}
                                                                    onChange={(e) => handleInputChange(index, e)}
                                                                    label=""
                                                                    variant="outlined"
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                            <Grid item xs={12} sm={12} md={3.2} lg={3} xl={2.6} display="flex-start" justifyContent="center">
                                                                <Typography variant="h6" fontSize={14} textAlign="left" required>
                                                                    Account Number
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={11} md={7.6} lg={7.2} xl={6.8}>

                                                                <TextField
                                                                    fullWidth
                                                                    size="small"
                                                                    name="accountNumber"
                                                                    value={bankDetail.accountNumber}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        // Allow only digits and limit length
                                                                        if (/^\d{0,18}$/.test(value)) {
                                                                            handleInputChange(index, e);
                                                                        }
                                                                    }}
                                                                    error={!/^\d{9,18}$/.test(bankDetail.accountNumber) && bankDetail.accountNumber.length > 0}
                                                                    helperText={
                                                                        bankDetail.accountNumber.length > 0 &&
                                                                            !/^\d{9,18}$/.test(bankDetail.accountNumber)
                                                                            ? "Enter a valid account number (9–18 digits)"
                                                                            : ""
                                                                    }
                                                                    onCopy={(e) => e.preventDefault()}
                                                                    onContextMenu={(e) => e.preventDefault()}
                                                                    onKeyDown={(e) => {
                                                                        if (e.ctrlKey && e.key === 'c') {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                    inputProps={{
                                                                        style: { userSelect: 'none' },
                                                                        inputMode: 'numeric',
                                                                    }}
                                                                    InputProps={{
                                                                        endAdornment: (
                                                                            <InputAdornment position="start">
                                                                                <IconButton
                                                                                    onClick={handleClickShowPassword}
                                                                                    onMouseDown={handleMouseDownPassword}
                                                                                    edge="end"
                                                                                >
                                                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                                                </IconButton>
                                                                            </InputAdornment>
                                                                        ),
                                                                    }}
                                                                    type={showPassword ? 'text' : 'password'}

                                                                    label="Account Number"
                                                                    variant="outlined"
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                            <Grid item xs={12} sm={12} md={3.2} lg={3} xl={2.6} display="flex-start" justifyContent="center">
                                                                <Typography variant="h6" fontSize={14} textAlign="left">
                                                                    Re-enter Account Number
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={11} md={7.6} lg={7.2} xl={6.8}>
                                                                <TextField
                                                                    fullWidth
                                                                    size="small"
                                                                    name="reEnterAccountNumber"
                                                                    value={bankDetail.reEnterAccountNumber}
                                                                    onChange={(e) => handleInputChange(index, e)}
                                                                    onBlur={() => {
                                                                        const acc = bankDetail.accountNumber?.trim();
                                                                        const reAcc = bankDetail.reEnterAccountNumber?.trim();
                                                                        if (acc !== reAcc) {
                                                                            setAccountMismatch(true);
                                                                        } else {
                                                                            setAccountMismatch(false);
                                                                        }
                                                                    }}
                                                                    error={accountMismatch}
                                                                    helperText={accountMismatch ? "Account numbers do not match" : ""}
                                                                    label="Re-enter Account Number"
                                                                    variant="outlined"
                                                                />

                                                            </Grid>
                                                            {index > 0 && (
                                                                <Grid item xs={12} sm={1} md={1} lg={1} xl={1}>
                                                                    <IconButton onClick={() => removeBankDetail(index)} color="secondary">
                                                                        <DeleteIcon />
                                                                    </IconButton>
                                                                </Grid>
                                                            )}
                                                        </Grid>
                                                    </Grid>


                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                                                            <Grid item xs={12} sm={12} md={3.2} lg={3} xl={2.6} display="flex-start" justifyContent="center">
                                                                <Typography variant="h6" fontSize={14} textAlign="left" required>
                                                                    Bank Letter
                                                                </Typography>
                                                            </Grid>

                                                            <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>
                                                                <Tooltip title="Bank Letter">
                                                                    <IconButton color="secondary" component="label">
                                                                        <CloudUploadIcon />
                                                                        <input
                                                                            type="file"
                                                                            hidden
                                                                            accept="application/pdf,image/*"
                                                                            onChange={(e) => handleBankLetterInputChange(index, e)}
                                                                        />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </Grid>
                                                            <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>
                                                                {bankDetail.bankLetter && (
                                                                    <Tooltip title="Download Bank Letter">
                                                                        <IconButton color="secondary" onClick={e => handleDownloadBankLetter(index, e, 'bank_letter')} >
                                                                            <DownloadIcon />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                )}
                                                            </Grid>
                                                            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                                                                {bankDetail.bankLetter && (
                                                                    <Typography variant="body2" sx={{ mt: 1 }}>{bankDetail.bankLetter_file_name}</Typography>
                                                                )}
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>

                                                <Grid container >

                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <Typography variant="h6" fontSize={16} textAlign="left" sx={{ marginTop: 2, marginBottom: 1 }}>
                                                            {/* Bank {index + 1} */}
                                                            Branch Details
                                                        </Typography>
                                                    </Grid>



                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                            <Grid item xs={12} sm={12} md={3.2} lg={3} xl={2.6} display="flex-start" justifyContent="center">
                                                                <Typography variant="h6" fontSize={14} textAlign="left">
                                                                    Account Type
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={11} md={7.6} lg={7.2} xl={5}>
                                                                <Autocomplete
                                                                    fullWidth
                                                                    size="small"
                                                                    options={bankAccounts}
                                                                    getOptionLabel={(option) => option.label}
                                                                    value={
                                                                        bankAccounts.find(
                                                                            (opt) => opt.id === bankDetail.accountTypeId
                                                                        ) || null
                                                                    }
                                                                    onChange={(event, newValue) =>
                                                                        handleAutocompleteChange(index, "accountTypeId", newValue ? newValue.id : null)
                                                                    }
                                                                    renderInput={(params) => <TextField {...params} variant="outlined" label="" />}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} sm={11} md={3.8} lg={1.5} xl={1.5}>
                                                                <Tooltip title="Add New Category" arrow>
                                                                    <IconButton style={{ fontSize: 5 }} size="small" color="secondary" onClick={handleOpenModal} >
                                                                        <AddCircleIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>


                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                            <Grid item xs={12} sm={12} md={3.2} lg={3} xl={2.6} display="flex-start" justifyContent="center">
                                                                <Typography variant="h6" fontSize={14} textAlign="left">
                                                                    Branch
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={11} md={7.6} lg={7.2} xl={6.8}>
                                                                <TextField
                                                                    fullWidth
                                                                    size="small"
                                                                    name="branchName"
                                                                    value={bankDetail.branchName}
                                                                    onChange={(e) => handleInputChange(index, e)}
                                                                    label=""
                                                                    variant="outlined"
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                            <Grid item xs={12} sm={12} md={3.2} lg={3} xl={2.6} display="flex-start" justifyContent="center">
                                                                <Typography variant="h6" fontSize={14} textAlign="left">
                                                                    Address
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={11} md={7.6} lg={7.2} xl={6.8}>
                                                                <TextField
                                                                    fullWidth
                                                                    size="small"
                                                                    name="bankAddress"
                                                                    value={bankDetail.bankAddress}
                                                                    onChange={(e) => handleInputChange(index, e)}
                                                                    label=""
                                                                    variant="outlined"
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                            <Grid item xs={12} sm={12} md={3.2} lg={3} xl={2.6} display="flex-start" justifyContent="center">
                                                                <Typography variant="h6" fontSize={14} textAlign="left" required>
                                                                    Contact Number
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={11} md={7.6} lg={7.2} xl={6.8}>
                                                                {/* <TextField
                                                                                      fullWidth
                                                                                      size="small"
                                                                                      name="contactNumber"
                                                                                      value={bankDetail.contactNumber}
                                                                                      onChange={(e) => handleInputChange(index, e)}
                                                                                      label=""
                                                                                      variant="outlined"
                                                                                    /> */}

                                                                <TextField
                                                                    value={bankDetail.contactNumber}
                                                                    onChange={(e) => {
                                                                        const input = e.target.value;
                                                                        if (/^\d*$/.test(input) && input.length <= 10) {
                                                                            handleInputChange(index, e);
                                                                        }
                                                                    }}
                                                                    fullWidth
                                                                    size="small"
                                                                    type="tel"
                                                                    label=""
                                                                    name="contactNumber"
                                                                    required
                                                                    variant="outlined"
                                                                    error={bankDetail.contactNumber !== '' && !/^[0-9]{10}$/.test(bankDetail.contactNumber)}
                                                                    helperText={
                                                                        bankDetail.contactNumber !== '' && !/^[0-9]{10}$/.test(bankDetail.contactNumber)
                                                                            ? 'Enter a valid 10-digit contact number'
                                                                            : ''
                                                                    }
                                                                    InputProps={{
                                                                        startAdornment: (
                                                                            <InputAdornment position="start">
                                                                                <PhoneIcon />
                                                                            </InputAdornment>
                                                                        ),
                                                                    }}
                                                                />


                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                            <Grid item xs={12} sm={12} md={3.2} lg={3} xl={2.6} display="flex-start" justifyContent="center">
                                                                <Typography variant="h6" fontSize={14} textAlign="left" required>
                                                                    Upload Cancelled Cheque
                                                                </Typography>
                                                            </Grid>

                                                            <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>

                                                                <Tooltip title="Upload Cancelled Cheque">
                                                                    <IconButton color="secondary" component="label">
                                                                        <CloudUploadIcon />
                                                                        <input
                                                                            type="file"
                                                                            hidden
                                                                            accept="application/pdf,image/*"
                                                                            onChange={(e) => handleChequeInputChange(index, e)}
                                                                        />
                                                                    </IconButton>
                                                                </Tooltip>

                                                            </Grid>

                                                            <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>
                                                                {bankDetail.cancelledCheque && (
                                                                    <Tooltip title="Download Cancelled Cheque">
                                                                        <IconButton color="secondary" onClick={e => handleDownloadBankLetter(index, e, 'cancel_cheque')} >
                                                                            <DownloadIcon />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                )}
                                                            </Grid>

                                                            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>

                                                                {bankDetail.cancelledCheque && (
                                                                    <Typography variant="body2" sx={{ mt: 1 }}>{bankDetail.cancelledCheque_file_name}</Typography>
                                                                )}
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                            <Grid item xs={12} sm={12} md={3.2} lg={3} xl={2.6} display="flex-start" justifyContent="center">
                                                                <Typography variant="h6" fontSize={14} textAlign="left" required>
                                                                    Upload RTGS Details
                                                                </Typography>
                                                            </Grid>

                                                            <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>

                                                                <Tooltip title="Upload RTGS Details">
                                                                    <IconButton color="secondary" component="label">
                                                                        <CloudUploadIcon />
                                                                        <input
                                                                            type="file"
                                                                            hidden
                                                                            accept="application/pdf,image/*"
                                                                            onChange={(e) => handleRTGSInputChange(index, e)}
                                                                        />
                                                                    </IconButton>
                                                                </Tooltip>

                                                            </Grid>
                                                            <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>
                                                                {bankDetail.rtgsDetail && (
                                                                    <Tooltip title="Download RTGS Detail">
                                                                        <IconButton color="secondary" onClick={e => handleDownloadBankLetter(index, e, 'rtgs')} >
                                                                            <DownloadIcon />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                )}
                                                            </Grid>
                                                            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>

                                                                {bankDetail.rtgsDetail && (
                                                                    <Typography variant="body2" sx={{ mt: 1 }}>{bankDetail.rtgsDetail_file_name}</Typography>
                                                                )}
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>



                                                </Grid>
                                            </Grid>

                                            {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={2}>
                                                            <Divider />
                                                        </Grid> */}
                                        </Grid>



                                    ))}

                                    {/* <Button
                                                    size='small'
                                                    sx={{ marginTop: "10px", textTransform: "none" }}
                                                    onClick={addBankDetail}
                                                    variant="standard"
                                                    color="primary"
                                                    startIcon={<AddIcon />}
                                                >
                                                    Add Bank Detail
                                                </Button> */}


                                </Box>
                                {/* 
                                        </Grid>
                                    </Grid>

                                </Grid> */}
                            </CardContent>
                        </Card>


                        <Card sx={{ backgroundColor: colors.primary[500], marginTop: '20px', marginBottom: '20px' }}>
                            <CardHeader title="Questionairre" />
                            <Divider />
                            <CardContent>
                                <Grid container spacing={2} padding={2}>

                                    <Grid item xs={12} xl={12} >
                                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"  >

                                            <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2} display="flex-start" justifyContent="center" >
                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Working for this organization again
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={4} lg={3.5} xl={3}>
                                                {/* <TextField value={workingOrganization} onChange={(e) => setWorkOrganization(e.target.value)} fullWidth size="small" /> */}
                                                <Autocomplete
                                                    options={yesNoOptions}
                                                    value={workingOrganization}
                                                    onChange={(event, newValue) => setWorkOrganization(newValue)}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="" size="small" fullWidth />
                                                    )}
                                                    disableClearable
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                                <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    What did you like the most of the organization
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={4} lg={3.5} xl={3}>
                                                <TextField value={likeOrganizationRemark} onChange={(e) => setLikeOrganizationRemark(e.target.value)} fullWidth size="small" />
                                            </Grid>

                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} xl={12} >
                                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"  >

                                            <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2} display="flex-start" justifyContent="center" >
                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Think the organization do to improve staff welfare
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={4} lg={3.5} xl={3}>
                                                <TextField value={improveStaffWalfareRemark} onChange={(e) => setImproveStaffWalfareRemark(e.target.value)} fullWidth size="small" />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                                <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Anything you wish to share with us
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={4} lg={3.5} xl={3}>
                                                <TextField value={wishToShareRemark} onChange={(e) => setWishToShareRemark(e.target.value)} fullWidth size="small" />
                                            </Grid>

                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>

                        {/* <Divider sx={{ marginTop: '20px', marginBottom: '20px' }} /> */}
                        {/* <Grid item xs={12}>
                            <Typography variant="h6" mt={2}>Check list for Exit Interview</Typography>
                        </Grid> */}
                        <Card sx={{ backgroundColor: colors.primary[500], marginTop: '20px', marginBottom: '20px' }}>
                            <CardHeader title="Check list for Exit Interview" />
                            <Divider />
                            <CardContent>
                                {/* <Grid container spacing={2} padding={2}>

                                    <Grid item xs={12} xl={12} ></Grid>
                                    <Grid item xs={12} xl={12} >
                                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center" >

                                            <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2} display="flex-start" justifyContent="center" >
                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Company Vehicle handed in
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={4} lg={3.5} xl={3}>
                                                <TextField value={companyVehicleHanded} onChange={(e) => setCompanyVehicleHanded(e.target.value)} fullWidth size="small" />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                                <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    All equipment handed in
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={4} lg={3.5} xl={3}>
                                                <TextField value={allEquipmentHanded} onChange={(e) => setAllEquipment(e.target.value)} fullWidth size="small" />
                                            </Grid>

                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} xl={12} >
                                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center" >

                                            <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2} display="flex-start" justifyContent="center" >
                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    All library book submitted
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={4} lg={3.5} xl={3}>
                                                <TextField value={libraryBookHanded} onChange={(e) => setLibraryBookHanded(e.target.value)} fullWidth size="small" />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                                <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Security
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={4} lg={3.5} xl={3}>
                                                <TextField value={securityHanded} onChange={(e) => setSecurityHanded(e.target.value)} fullWidth size="small" />
                                            </Grid>

                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} xl={12} >
                                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center" >

                                            <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2} display="flex-start" justifyContent="center" >
                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Exit interview conducted
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={4} lg={3.5} xl={3}>
                                                <TextField value={exitInterViewHanded} onChange={(e) => setExitInterViewHanded(e.target.value)} fullWidth size="small" />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                                <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    notice period followed
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={4} lg={3.5} xl={3}>
                                                <TextField value={noticePeriodFollowed} onChange={(e) => setNoticePeriodFollowed(e.target.value)} fullWidth size="small" />
                                            </Grid>

                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} xl={12} >
                                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center" >

                                            <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2} display="flex-start" justifyContent="center" >
                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Resignation letter submitted
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={4} lg={3.5} xl={3}>
                                                <TextField value={resignationLetterSubmitted} onChange={(e) => setResignationLetterSubmitted(e.target.value)} fullWidth size="small" />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                                <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Manager/Supervisor clearance
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={4} lg={3.5} xl={3}>
                                                <TextField value={managerClearnce} onChange={(e) => setManagerClearnce(e.target.value)} fullWidth size="small" />
                                            </Grid>

                                        </Grid>
                                    </Grid>
                                </Grid> */}
                                <ExitInterviewChecklist formData={formData} setFormData={setFormData} />
                            </CardContent>
                        </Card>

                        {/* <Divider sx={{ marginTop: '20px', marginBottom: '20px' }} /> */}

                        <Card sx={{ backgroundColor: colors.primary[500], marginTop: '20px', marginBottom: '20px' }}>
                            <CardHeader title="Documents" />
                            <Divider />
                            <CardContent>
                                <Grid container spacing={2} padding={2}>

                                    <Grid item xs={12} xl={12} >
                                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"  >

                                            <UploadSection
                                                label="Resignation/Retirement Letter"
                                                type="Resignation"
                                                file={documents.Resignation.file}
                                                onFileChange={handleFileChange}
                                                onDownload={handleDownload}
                                            />


                                            <UploadSection
                                                label="HR clearness certificate"
                                                type="HRClearness"
                                                file={documents.HRClearness.file}
                                                onFileChange={handleFileChange}
                                                onDownload={handleDownload}
                                            />

                                        </Grid>

                                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"  >
                                            <UploadSection
                                                label="Death Certificate *"
                                                type="DeathCertificate"
                                                file={documents.DeathCertificate.file}
                                                onFileChange={handleFileChange}
                                                onDownload={handleDownload}
                                            />

                                        </Grid>
                                    </Grid>

                                </Grid>
                            </CardContent>
                        </Card>

                        {/* <Card sx={{ backgroundColor: colors.primary[500], marginTop: '20px', marginBottom: '20px' }}>
                            <CardHeader title="Documents" />
                            <Divider />
                            <CardContent>
                                <ExitInterviewChecklist formData={formData} setFormData={setFormData} />
                            </CardContent>
                        </Card> */}
                        {/* 
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center" >

                                <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                    <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Exit Interview Details
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={8} xl={8}>
                                    <TextField value={exitInterviewDetails} multiline onChange={(e) => { setExitInterviewDetails(e.target.value) }} fullWidth label="" required variant="outlined" />
                                </Grid>
                            </Grid>

                        </Grid> */}

                        {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center" >

                                <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                    <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Settlement Status
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={8} xl={8}>
                                    <TextField value={settlementStatus} size="small" onChange={(e) => { setSettlementStatus(e.target.value) }} fullWidth label="" required variant="outlined" />
                                </Grid>
                            </Grid>

                        </Grid> */}

                    </Grid>

                </Grid >

            </Box >
        </Box >

    </>)
}
export default ExitEmployee;